import { Component, OnInit, Inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { MAT_DIALOG_DATA } from '@angular/material/dialog';

/**
 * Summary
 *    Modal dialog used for playing YouTube videos
 *
 *
 * Description
 *    Embeds a YouTube video in an internal iframe allowing a user to view the
 *    video within the modal dialog.
 *
 * @copyright 2017 ReallyB2B Limited
 */
@Component({
  selector: 'app-youtube-modal',
  templateUrl: './youtube-modal.component.html'
})
export class YoutubeModalComponent implements OnInit {

  public safeVideoUrl: SafeResourceUrl;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    const videoUrl = this.data.videoUrl;
    if (this.isTrustedVideoUrl(videoUrl)) {
      this.safeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(videoUrl);
    }
  }

  /**
   * Returns true if the given URL is a trusted YouTube embed URL.
   *
   * @param {any} url The URL to check
   * @return {boolean}
   */
  private isTrustedVideoUrl(url: any): boolean {
    if (typeof url !== 'string') {
      return false;
    }
    // Basic check to ensure the URL is from YouTube embed
    return url.startsWith('https://www.youtube.com/embed/') || url.startsWith('https://youtube.com/embed/');
  }
}
